import templates from "../templates";

import jQuery from "jquery";
import { EVENT } from "../data/constants";
import SERVICE_REGISTRY from "../services/registry";
import { SETTINGS } from "../settings";
import {
    EventManager,
    addBrandIconMarker,
    concatenateStoreAddress,
    concatenateStoreHours,
    formatStoreDistanceValue,
    open247,
} from "../utils/global";

const $ = jQuery;

export default class ResultView extends woosmap.map.MVCObject {
    constructor(mainView) {
        super();
        this.selector = "#storemap-storelistbar-container";
        this.refreshlistSelector = "#storemap-storelistbar-container .storemap-storelistbar-refresh-button";

        this.mainView = mainView;

        this.mainElement = $(this.selector);
        this.refreshlistElement = $(this.refreshlistSelector);
        this.currentStores = [];

        this._wireEvents();
    }

    _wireEvents() {
        const self = this;

        function onStoreContainerClick(event) {
            const container = $(this);
            // Dirty -1, because storelistbar is ahead of every storelist-items in the collection
            // Everything was accessed with the wrong index ...
            const index = container.index() - 1;

            self.mainView.setSelectedStore(self.currentStores[index]);
            self.mainView.setStoreDetails(self.currentStores[index]);
            self.mainView.showDetail();

            EventManager.notify(EVENT.MORE_INFORMATION_CLICKED, self.currentStores[index].properties.store_id);

            event.stopPropagation();
        }

        function onGoButtonClick(event) {
            const container = $(this).closest(".storemap-storelistitem-container");
            const index = container.index() - 1;

            self.mainView.setStoreDetails(self.currentStores[index]);

            self.mainView.showDirection();
            event.stopPropagation();

            EventManager.notify(EVENT.GO_CLICKED, self.currentStores[index].properties.store_id);
        }

        function onCallLinkClick(event) {
            EventManager.notify(EVENT.CALL_CLICKED);
            window.open(this.attr("href"), "_blank");
            event.stopPropagation();
            return false;
        }

        function onRefreshButtonClick() {
            self.mainView.mapView.is_center_changed = false;

            self.mainView.onRefreshList();

            const blockSearchNearbyStores = SERVICE_REGISTRY.itinaryService.getDestination() !== null;
            const center = self.mainView.mapView.map.getCenter();
            SERVICE_REGISTRY.locationService.setLocation(
                { lng: center.lng(), lat: center.lat() },
                "coucou",
                blockSearchNearbyStores,
            );
            self.refreshlistElement.hide();
        }

        this.mainElement.on("click", ".storemap-storelistitem-direction-button", onGoButtonClick);
        this.mainElement.on("click", ".storemap-maplistitem-telephone-link", onCallLinkClick);
        this.mainElement.on("click", ".storemap-storelistitem-container", onStoreContainerClick);
        this.mainElement.on("click", ".storemap-storelistbar-refresh-button", onRefreshButtonClick);
    }

    show() {
        this.mainElement.show();

        if (SETTINGS.itinerary) {
            if (SERVICE_REGISTRY.storeService.itinarySearch) {
                this.refreshlistElement.hide();
            } else if (this.mainView.mapView.is_center_changed) {
                this.refreshlistElement.show();
            } else {
                this.refreshlistElement.hide();
            }
        } else if (this.mainView.mapView.is_center_changed) {
            this.refreshlistElement.show();
        } else {
            this.refreshlistElement.hide();
        }
    }

    // Not sure about location so not removing for the moment
    // eslint-disable-next-line no-unused-vars
    onCenterChange(location) {
        this.refreshlistElement.show();
    }

    onStoresChange(stores) {
        this.currentStores = stores;

        // this.mainElement.empty();
        this.mainElement.find(".storemap-storelistitem-container").remove();
        stores.forEach((store, index) => {
            const item = $(
                $.parseHTML(
                    templates.mobile.resultItem.render({ ui: total.maps.L10n.ui, itinerary: SETTINGS.itinerary }),
                ),
            );

            // index css
            item.addClass(`storemap-${Number.parseInt(index, 10) + 1}-item`);
            item.attr("id", `storemap-store-id-${store.properties.store_id}`);

            // icon
            const logoItem = item.find(".storemap-storelistitem-logo");
            addBrandIconMarker(logoItem[0], store);

            // name
            item.find(".storemap-storelistitem-storename").text(store.properties.name);

            // type
            const type = store.properties.user_properties.poiType;
            const poiTypeToDisplay = total.maps.L10n.ui.poiType[type] ? total.maps.L10n.ui.poiType[type] : type;
            item.find(".storemap-storelistitem-storetype").text(poiTypeToDisplay);

            // hours
            if (store.properties.open?.open_now) {
                const hoursText = concatenateStoreHours(store.properties.open.open_hours);
                item.find(".storemap-storelistitem-todayshours div").text(
                    `${total.maps.L10n.ui.common.today} ${hoursText}`,
                );
            } else {
                item.find(".storemap-storelistitem-todayshours").hide();
            }

            // open 24/7
            item.find(".storemap-storelistitem-24hours").toggle(open247(store));

            // distance
            if (store.properties.distance) {
                const distanceText = formatStoreDistanceValue(store);
                item.find(".storemap-storelistitem-distance").text(distanceText);
            }

            // address
            const address = concatenateStoreAddress(store);

            item.find(".storemap-storelistitem-infos div").text(address);

            if (store.properties.contact?.phone) {
                item.find(".storemap-maplistitem-telephone-link").prop("href", `tel:${store.properties.contact.phone}`);
            }

            this.mainElement.append(item);
        });
    }
}
